import { __ } from '@wordpress/i18n';
import { PanelBody, PanelRow, RangeControl } from '@wordpress/components';
import { BDevice, BorderControl, ColorControl, Label } from '../../../../Components';

const Button = ({ attributes, setAttributes, device, setDevice }) => {
    const { btnBorder, btnSize, btnColor, btnBgColor, btnActiveColor } = attributes
    return <>
        <PanelBody title={__('Button', 'swipe-n-buy')} initialOpen={false}>
            <BorderControl className='' label={__('Border', 'swipe-n-buy')} value={btnBorder}
                onChange={(val) => { setAttributes({ btnBorder: val }) }} />

            <PanelRow>
                <Label mt='0'>{__('Size', 'swipe-n-buy')}</Label>
                <BDevice device={device} onChange={val => setDevice(val)} />
            </PanelRow>

            <RangeControl value={btnSize[device]} onChange={val => { setAttributes({ btnSize: { ...btnSize, [device]: val } }) }} step={1} beforeIcon='grid-view' />

            <ColorControl className='mb15' label={__('Color', 'swipe-n-buy')} value={btnColor} onChange={(val) => setAttributes({ btnColor: val })} />

            <ColorControl className='mb15' label={__('Active Color', 'swipe-n-buy')} value={btnActiveColor} onChange={(val) => setAttributes({ btnActiveColor: val })} />

            <ColorControl className='mb15' label={__('Background Color', 'swipe-n-buy')} value={btnBgColor} onChange={(val) => setAttributes({ btnBgColor: val })} />

        </PanelBody>
    </>
}
export default Button;